import Link from "@client/controls/Link/container";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export interface LoginProps {
  url: string;
}

const AdminLogin = (props: LoginProps) => {
  const i18n = useI18n();

  return (
    <div className="login">
      <Link title={i18n.adminLogin} rel="nofollow" to={props.url}>
        {i18n.adminLogin}
      </Link>
    </div>
  );
};

export default AdminLogin;
